export default "__VITE_ASSET__HesBhKp3__"